import { media as mediaStore } from '$lib/Stores/stores';

import { get } from 'svelte/store';

import type { Media } from '$lib/types/LayoutData';

export const getMediaById = (mediaId: string) => {
    if (!mediaId) {
        return null;
    }

    const media = get<Record<string, Media>>(mediaStore);

    return media?.[mediaId] ?? null;
};
